import {
  ReactSelectPlaceholder,
  ReactSelectStyles,
} from "@/consts/ReactSelect";
import useFindEntityWithSubEntities from "@/hooks/useFindEntityWithSubEntitites";
import { FC, useMemo } from "react";
import Select from "react-select";

type Entity = {
  id: number;
  ancestry: number[];
  children?: Entity[];
  name: string;
};

interface Props {
  existEntities: Entity[];
  instanceId: string;
  onChange: (value) => void;
  selectedId?: number;
}

const MultiSelect: FC<Props> = ({
  existEntities,
  instanceId,
  selectedId,
  onChange,
}): JSX.Element => {
  const { selectedEntity, parentEntities, orderedEntities } =
    useFindEntityWithSubEntities<Entity>(existEntities, selectedId?.toString());

  // 現在選択しているEntityから、表示するためのOption用の配列をつくる
  const optionEntityGroup = useMemo(() => {
    // カテゴリを指定しない場合
    if (!selectedEntity) {
      return [existEntities];
    }

    // カテゴリを指定しているが、親がない場合
    if (parentEntities.length < 1) {
      return [existEntities, selectedEntity.children];
    }

    const entities = [existEntities, ...parentEntities.map((e) => e.children)];

    if (selectedEntity.children && selectedEntity.children.length > 0) {
      entities.push(selectedEntity.children);
    }

    return entities;
  }, [selectedEntity, parentEntities, existEntities]);

  return (
    <div className="space-y-4">
      {optionEntityGroup.map((optionEntities, index) => {
        return (
          <Select
            key={index}
            instanceId={`${instanceId}-${index}`}
            options={optionEntities.map((entity) => {
              return {
                value: entity.id,
                label: entity.name,
              };
            })}
            onChange={onChange}
            value={
              orderedEntities[index]
                ? {
                    value: orderedEntities[index].id,
                    label: orderedEntities[index].name,
                  }
                : null
            }
            styles={ReactSelectStyles}
            placeholder={ReactSelectPlaceholder}
          />
        );
      })}
    </div>
  );
};
export default MultiSelect;
